<template>
    <div class="companies-box transition" id="companies-box">
        <div class="companies-title-box banCopy">
            <h4 class="companies-title-text">关联企业链接</h4>
        </div>
        <div
            class="swiper-container swiper-container-initialized swiper-container-horizontal banCopy col-xl-8 col-lg-10">
            <div class="swiper-wrapper">
                <div class="swiper-slide swiper-companies" v-for="(item, index) in SwiperArr" :key="index"
                    data-swiper-slide-index="index">
                    <a :href="item.link" target="_blank">
                        <img class="col-9 col-lg-11" :src="item.img_url">
                    </a>
                </div>
            </div>
            <div class="swiper-button-prev" id="prev-but" tabindex='0' role="button" aria-label="Previous slide"></div>
            <div class="swiper-button-next" id="next-but" tabindex='0' role="button" aria-label="Next slide"></div>
        </div>
    </div>

</template>

<script>
import '../swiper/swiper-bundle.min.css'
import Swiper from '../swiper/swiper-bundle.min.js'
export default {
    mounted() {
        this.PostCompany();
    },
    methods: {
        PostCompany(url) {
            var url = "http://demoapi.hkjt.cn/pages/company.php?swiper=swiper"
            var arr = new Array();
            var arr1 = new Array();
            this.axios.get(url).then(res => {
                for (var i = 1; i <= 3; i++) {
                    arr.push(res.data);
                }
                var num = 0;
                for (var i = 0; i < arr.length; i++) {
                    for (var j = 0; j < arr[i].length; j++) {
                        //console.log(arr[i][j])
                        arr1[num] = arr[i][j];
                        num++
                    }
                }
                this.SwiperArr = arr1
                this.$nextTick(() => {
                    this.swiper();
                });
            })

        },

        swiper() {
            var comSwiper = new Swiper('.swiper-container', {
                loop: true,
                speed: 400,
                slidesPerView: 7,
                spaceBetween: 30,
                centeredSlides: true,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                observer: true,//修改swiper自己或子元素时，自动初始化swiper
                observeParents: true,//修改swiper的父元素时，自动初始化swiper
            });
        }
    },
    data() {
        return {
            SwiperArr: [],
        }
    },
}
</script>

<style scoped>
.companies-title-text{
    color: rgba(54, 54, 54, 0.925);
    font-size: 1.5rem;
}

.companies-title-box {
    text-align: center;
    padding: 6rem 0 0 0;
}

.swiper-button-prev,
.swiper-button-next {
    color: #989899;
    background-color: #fff;
    width: 3rem;
    height: 100%;
    top: 1%;
    display: flexs;
}

#prev-but {
    left: 0;
    display: flex;
    justify-items: center;
}

#next-but {
    right: 0;
    display: flex;
    justify-items: center;
}

.companies-box {
    width: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
}

#companies-box {
    padding: 0;
}

.swiper-container {
    height: auto;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    background-color: #fff;
    overflow: hidden;
    padding: 3rem 0 5rem 0;
}

.swiper-companies {
    text-align: center;
    width: 20% !important;
    background: #fff;
    /* height: 200px; */
    margin-right: 0 !important;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    transition-property: all;
}

#progressEffect {
    position: absolute;
    z-index: 10;
    top: 20px;
    left: 20px;
}

@media screen and (max-width:991px) {

    #prev-but,
    #next-but {
        display: none;
    }

    .swiper-companies {
        width: 25% !important;
    }
}
</style>